var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0339 8.77561C24.8723 8.28765 24.429 7.94108 23.9045 7.89493L16.7803 7.26338L13.9631 0.825992C13.7554 0.354215 13.2824 0.0488281 12.7567 0.0488281C12.2311 0.0488281 11.7581 0.354215 11.5504 0.827095L8.73324 7.26338L1.60787 7.89493C1.08433 7.94218 0.642153 8.28765 0.479631 8.77561C0.317108 9.26356 0.467201 9.79877 0.863243 10.1361L6.24832 14.7469L4.66039 21.5759C4.54419 22.078 4.74381 22.5971 5.17055 22.8982C5.39993 23.06 5.66829 23.1424 5.93891 23.1424C6.17224 23.1424 6.40369 23.081 6.61141 22.9596L12.7567 19.3739L18.8998 22.9596C19.3493 23.2236 19.916 23.1996 20.3418 22.8982C20.7687 22.5961 20.9682 22.0769 20.852 21.5759L19.264 14.7469L24.6491 10.1371C25.0452 9.79877 25.1964 9.26448 25.0339 8.77561Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.33786d8931ec271f360ba08f31f64ae0.svg";
export { ForwardRef as ReactComponent };